import { requestCreate, requestDelete, requestUpdate, sendRequest } from "../api"
import { ADD_IN_LIST, FORM_ACCOUNT_SELECTED, FORM_RESET_PARENT_ACCOUNT, REMOVE_IN_LIST, RESET_FORM, RESET_STATE, SET_FORM, SET_LIST, UPDATE_IN_LIST } from "../constant-types"
import { getField, updateField } from 'vuex-map-fields'
const getDefaultState = () => {
    return {
        someInitialState: true,
        list : [],
        form : getDefaultFormState()
    }
}

const getDefaultFormState = () => {
    return {
        id: '',
        account_class_id : '',
        parent_account_id : '',
        code_full : '',
        name : '',
        status_active : true,
        normal_position: 'debit', // debit | credit
        fillable: false
    }
}

export default ({
    namespaced: true, //
    // variable
    state: getDefaultState(),
    // must syncronous
    mutations: {
        [RESET_STATE](state) {
            // Merge rather than replace so we don't lose observers
            // https://github.com/vuejs/vuex/issues/1118
            Object.assign(state, getDefaultState())
        },
        [ADD_IN_LIST](state, newAccount) {
            state.list.unshift(newAccount)
        },
        [SET_LIST](state, payload) {
            state.list = payload
        },
        [SET_FORM](state, payload) {
            // state.form = payload
            Object.assign(state.form, payload)
        },
        [REMOVE_IN_LIST](state, account) {
            let idx = state.list.findIndex(l => l.id == account.id)
            state.list.splice(idx, 1)
        },
        [RESET_FORM](state) {
            state.form = getDefaultFormState()
        },
        [UPDATE_IN_LIST](state, account) {
            let idx = state.list.findIndex(l => l.id == account.id)
            Object.assign(state.list[idx], account)
        },
        updateField,
        [FORM_RESET_PARENT_ACCOUNT](state) {
            state.form.parent_account_id = 0;
            state.form.code_full = '';
        },
        [FORM_ACCOUNT_SELECTED](state, accountId) {
            let account = state.list.find(l => l.id == accountId)
            let count = state.list.filter(l => l.parent_account_id == accountId).length
            // console.log('debug : x ');
            // console.log(x);
            state.form.parent_account_id = accountId;
            state.form.account_class_id = account.account_class_id;
            state.form.code_full = account.code_full + '.' + (+count+1);
        }

    },
    // can async
    actions: {
        loadList({commit}) {
            return sendRequest('account', {}, 'get', (response) => commit(SET_LIST, response), ()=>{}, ()=>{})
        },
        requestCreateAccount({commit, state}) {
            return requestCreate('account', state.form, commit)
        },
        requestUpdateAccount({commit, state}) {
            return requestUpdate('account', state.form, commit)
        },
        requestDeleteAccount({commit}, account) {
            return requestDelete(`account/${account.id}`, {}, commit, account.name)
        }
    },
    // call variable with custom display
    getters: {
        listExceptId: state => exceptId => {
            return state.list.filter(l => l.id !== exceptId)
        },
        listFillable: state => {
            return state.list.filter(l => l.fillable == true)
        },
        listSorted: state => {
            // sort by code full
            return _.sortBy(state.list, 'code_full')
        },
        /* listNested : (state, getters, rootState, rootGetters) => {
            let listRoots = state.list.filter(l => l.parent_account_id == 0)
            let creationList = [] // creation
            _.each(listRoots, function(listRoot) {
                creationList.push(generateNesting(listRoot, state.list))
            })

            function generateNesting(list, fullList) {
                let listChildrens = fullList.filter(fl => fl.parent_account_id == list.id)
                // if have children 
                if ( listChildrens.length > 0 ) {
                    let c = [] // creation of children
                    _.each(listChildrens, function (listChildren) {
                        c.push(generateNesting(listChildren, fullList))
                    })
                    list.childs = c;
                    return list;
                } 
                // if no
                else {
                    return list;
                }
            }
            
            // group by account class
            let listClass = rootState.accountClass.options
            let s = _.map(listClass, function(lc) {
                let insideLists = creationList.filter(cl => cl.account_class_id == lc.id)
                if (insideLists.length > 0) {
                    lc.accounts = insideLists
                }
                return lc
            })
            return s;
        },
        listNestedGroupBySide: (state, getters) => {
            return _.groupBy(getters.listNested, 'side')
        }, */
        listGroupByClass: (state, getters, rootState, rootGetters) => {
            return _.map(rootState.accountClass.options, function(c) {
                return state.list.filter(l => l.account_class_id == c.id)
            })  
        },
        getField

    }
})
